import React, {Component} from "react";
import Xhr from "../../helpers/Xhr";
import EventHelper from "../../helpers/EventHelper";
import {Link} from "react-router-dom";
import SportIcon from "../../components/SportIcon";
import MomentDate from "../../components/MomentDate";

class Search extends Component {
	state = {
		events   : [],
		messages : []
	};

	componentWillMount() {
		const {text} = this.props.location;
		if ( text === undefined || text === '' ) {
			this.setState({
				messages : ['Задан пустой поисковый запрос!']
			});

			return;
		}

		const data = {
			search : text
		};

		Xhr.search(data).then((resp) => {
			if ( resp.status === 'ok' ) {
				this.setState({
					events   : resp.data,
					messages : []
				});
			}
			else {
				this.setState({
					events   : [],
					messages : resp.messages
				});
			}
		});
	}

	render() {
		const data = this.state.events.map((event) => {
			const type = +event.eventType;
			const eventId = +event.eventId;
			const leagueId = +event.leagueId;
			const sportId = +event.sportId;

			const path = type === 1 ? `/live/${eventId}` : `/line-leagues/${leagueId}/${eventId}`;

			return (

				<div className="events__table table-div">
					<div className="events__header thead">
						<div className="tr">
							<div className="th">&nbsp;</div>
							<div className="th sportname">
								<span className="sport-icon small green events__header__sporticon">
									<SportIcon sportId={sportId}/>
								</span>&nbsp;
								{`${event.sportName}. ${event.leagueName}`}
							</div>
						</div>
					</div>
					<div className="tbody">
						<div className="tr">
							<div className="td players">
								&nbsp;{type === 1 && <span className="cl-red">Live.&nbsp;</span>}
								<Link to={path}>{EventHelper.parseTeams(event.team1, event.team2)}</Link>
							</div>
							<div className="td score">
								<MomentDate date={event.time} isFormatDate={true}/>
							</div>
						</div>
					</div>
				</div>
			)
		});

		return (
			<div key="search" className="body__container__side-right">
				<div className="live-event-header">
					<div>Результаты поиска</div>
				</div>

				{this.state.messages.length > 0 ?
					<div className="search__error">{this.state.messages.join(<br/>)}</div> :
					<div className="events">{data}</div>}

			</div>
		);
	}
}

export default Search;


// WEBPACK FOOTER //
// ./src/app/pages/Search/Search.js